"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterCount = void 0;

var _react = _interopRequireWildcard(require("react"));

var _characterCount = _interopRequireDefault(require("govuk-frontend/govuk/components/character-count/character-count"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CharacterCount = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var id = props.id,
      className = props.className,
      maxlength = props.maxlength,
      threshold = props.threshold,
      maxwords = props.maxwords,
      errorMessage = props.errorMessage,
      countMessage = props.countMessage,
      attributes = _objectWithoutProperties(props, ["id", "className", "maxlength", "threshold", "maxwords", "errorMessage", "countMessage"]);

  var characterCountRef = (0, _react.useRef)();
  var characterCountInfoId = "".concat(id, "-info");
  (0, _react.useEffect)(function () {
    new _characterCount["default"](characterCountRef.current).init();
  }, [characterCountRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "govuk-character-count",
    "data-module": "govuk-character-count",
    "data-maxlength": maxlength,
    "data-threshold": threshold,
    "data-maxwords": maxwords,
    ref: characterCountRef
  }, /*#__PURE__*/_react["default"].createElement(_.Textarea, _extends({
    id: id
  }, attributes, {
    errorMessage: errorMessage,
    className: "govuk-js-character-count ".concat(className || '').concat(errorMessage ? ' govuk-textarea--error' : ''),
    "aria-describedby": characterCountInfoId,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement(_.Hint, {
    id: characterCountInfoId,
    className: "govuk-hint govuk-character-count__message ".concat((countMessage === null || countMessage === void 0 ? void 0 : countMessage.className) || ''),
    "aria-live": "polite"
  }, "You can enter up to ", maxlength || maxwords, ' ', maxwords ? 'words' : 'characters'));
});

exports.CharacterCount = CharacterCount;
CharacterCount.displayName = 'CharacterCount';